<template>
  <div class="app-container">
    <el-form
      :model="queryParams"
      ref="queryForm"
      size="small"
      :inline="true"
      label-width="68px"
    >
      <el-form-item label="关键字" prop="keyWord">
        <el-input
          v-model="queryParams.condition.keyWord"
          placeholder="请输入项目名称"
          clearable
          style="width: 240px"
        />
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          icon="el-icon-search"
          size="mini"
          @click="handleQuery"
          >搜索</el-button
        >
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery"
          >重置</el-button
        >
      </el-form-item>
    </el-form>

    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button
          type="primary"
          plain
          icon="el-icon-plus"
          size="mini"
          @click="handleAdd"
          v-if="qx"
          >创建工单</el-button
        >
      </el-col>
      <el-col :span="1.5"> </el-col>
    </el-row>

    <el-table
      v-loading="loading"
      :data="userList"
      :row-style="{ height: '58px' }"
      height="calc(100vh - 280px)"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      border
    >
      <el-table-column
        label="工单编号"
        align="center"
        prop="orderNo"
        width="150"
        sortable
        :show-overflow-tooltip="true"
      />
      <el-table-column
        label="	部门名称"
        align="center"
        prop="deptName"
        width="200"
        :show-overflow-tooltip="true"
      />
      <el-table-column
        label="项目名称"
        align="center"
        prop="projectName"
        :show-overflow-tooltip="true"
      />
      <el-table-column
        label="工单名称"
        align="center"
        prop="name"
        :show-overflow-tooltip="true"
      />
      <el-table-column
        label="工单需求描述"
        align="center"
        prop="description"
        :show-overflow-tooltip="true"
      >
      </el-table-column>

      <el-table-column
        label="工单状态"
        align="center"
        prop="orderStatus"
        width="120"
      >
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.orderStatus != 'wait_received'"
            :type="scope.row.orderStatus == 'finish' ? 'info' : ''"
            >{{ scope.row.orderStatus | StatusFiltering }}</el-tag
          >
          <el-tag
            type="warning"
            v-if="scope.row.orderStatus == 'wait_received'"
            >{{ scope.row.orderStatus | StatusFiltering }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column
        label="发起人"
        align="center"
        prop="trueName"
        :show-overflow-tooltip="true"
        width="80"
      >
      </el-table-column>
      <el-table-column
        label="操作时间"
        align="center"
        prop="updateTime"
        width="160"
        :show-overflow-tooltip="true"
        sortable
      
      :formatter="dateTimeTwoLine"
      class-name="cell-two-line"
      >
        <template slot-scope="scope">
          {{ scope.row.updateTime | timestampToTime }}
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        header-align="center"
        align="center"
        width="250"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="handleAccept(scope.row)"
            :disabled="scope.row.orderStatus != 'wait_received'"
            v-if="
              scope.row.orderStatus != 'finish' &&
              qx1 &&
              scope.row.deptId == DEPARTMENTID
            "
            >工单拆分</el-button
          >
          <el-button
            type="danger"
            size="mini"
            style="margin-left: 10px"
            @click="Alteration(scope.row)"
            v-if="
              scope.row.orderStatus != 'finish' &&
              qx &&
              scope.row.createBy == UID
            "
            :disabled="scope.row.orderStatus != 'wait_received'"
            >变更工单</el-button
          >
          <el-button
            size="mini"
            type="success"
            v-if="
              scope.row.orderStatus == 'finish' &&
              scope.row.evalId == null &&
              scope.row.isEvaluate == 1
            "
            style="padding: 6px 10px; margin: 6px 5px"
            @click="handleResult(scope.row)"
            >评价</el-button
          >

          <el-dropdown size="mini">
            <el-button
              size="mini"
              type="warning"
              icon="el-icon-d-arrow-right"
              style="padding: 6px 5px"
              >更多</el-button
            >
            <el-dropdown-menu slot="dropdown">
              <el-button
                size="mini"
                type="success"
                style="margin: 0 5px"
                @click="viewDetails(scope.row)"
                >工单详情</el-button
              >
              <el-button
                type="info"
                size="mini"
                v-if="scope.row.orderFileUrl != ''"
                style="margin: 6px 5px"
                @click="downloadFile(scope.row)"
                >附件下载</el-button
              >
              <el-button
                size="mini"
                type="success"
                v-if="scope.row.evalId != null"
                style="margin: 6px 5px"
                @click="handleDetails(scope.row)"
                >评价详情</el-button
              >
              <el-button
                size="mini"
                type="danger"
                plain
                style="padding: 6px 10px; margin: 6px 5px"
                v-if="
                  scope.row.orderStatus == 'wait_received' &&
                  qx &&
                  scope.row.createBy == UID
                "
                @click="deleteWorkOrder(scope.row)"
                >删除</el-button
              >
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="queryParams.page"
      :limit.sync="queryParams.limit"
      :pageSizes="[50, 100, 200, 500]"
      @pagination="getList"
    />
    <!-- 添加或修改工单对话框 -->
    <el-dialog
      :title="title"
      :visible.sync="open"
      width="700px"
      append-to-body
      :destroy-on-close="true"
      :close-on-click-modal="false"
      @close="handleClose"
    >
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="80px"
        class="dialog-box"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item label="项目名称" label-width="110px">
              <!--  filterable -->
              <el-select
                v-model="form.projectId"
                placeholder="请选择"
                size="mini"
                filterable
                style="width: 70%"
              >
                <el-option
                  v-for="item in projects"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="工单名称" prop="name" label-width="110px">
              <el-input
                v-model="form.name"
                placeholder="请输入工单名称"
                style="width: 70%"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="指派部门名称"
              prop="deptId"
              label-width="124px"
            >
              <treeselect
                v-model="form.deptId"
                :options="deptOptions"
                :default-expand-level="2"
                :normalizer="normalizer"
                placeholder="请选择部门名称"
                @select="handleSelect"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="人员" prop="personId">
              <el-select
                v-model="form.personId"
                style="margin-left: 20px"
                placeholder="请选择"
                clearable
              >
                <el-option
                  v-for="item in CeOptions"
                  :key="item.id"
                  :label="item.trueName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="期望完成时间"
              prop="endDate"
              label-width="124px"
            >
              <!-- <el-date-picker
                v-model="form.startDate"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
                @change="calculateDays"
                :picker-options="pickerOptionsStart"
              >
              </el-date-picker> -->
              <el-date-picker
                v-model="form.endDate"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                @change="calculateDays"
                :picker-options="pickerOptionsEndCreated"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="是否语音通知"
              prop="callFlag"
              label-width="135px"
            >
              <!-- <el-date-picker
                v-model="form.endDate"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                @change="calculateDays"
                :picker-options="pickerOptionsEndCreated"
              >
              </el-date-picker> -->
              <el-switch style="margin-top: 6px" v-model="form.callFlag">
              </el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item
              label="工单需求描述"
              prop="description"
              label-width="124px"
            >
              <el-input
                v-model="form.description"
                type="textarea"
                placeholder="请输入内容"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="上传附件" label-width="100px">
              <el-upload
                class="upload-demo"
                :action="this.$store.state.IPAss.TP + '/work/file/upload/1'"
                :headers="customHeaders"
                :before-remove="beforeRemove"
                :on-remove="handleRemove"
                :on-success="handleSuccess"
                multiple
                :file-list="FileUrl"
                name="multipartFile"
              >
                <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm" :loading="submitLoading"
          >确 定</el-button
        >
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 部门主管拆分任务 -->
    <el-dialog
      title="任务拆分"
      :visible.sync="resolveOpen"
      width="80%"
      append-to-body
      :destroy-on-close="true"
      :close-on-click-modal="false"
    >
      <div class="xx-flex xx-flex-wrap">
        <div style="width: 45%" class="xx-p-12">
          <span>项目名称：</span>
          <span class="xx-content-color">{{ Tabular.projectName }}</span>
        </div>
        <div style="width: 45%" class="xx-p-12">
          <span>部门名称：</span>
          <span class="xx-content-color">{{ Tabular.deptName }}</span>
        </div>
        <div style="width: 45%" class="xx-p-12">
          <span>工单开始日期：</span>
          <span class="xx-content-color">{{
            Tabular.startDate | timestampToTimeB
          }}</span>
        </div>
        <div style="width: 45%" class="xx-p-12">
          <span>工单结束日期：</span>
          <span class="xx-content-color">{{
            Tabular.endDate | timestampToTimeB
          }}</span>
        </div>
        <div style="width: 45%" class="xx-p-12">
          <span>工单名称：</span>
          <span class="xx-content-color">{{ Tabular.name }}</span>
        </div>
        <div style="width: 45%" class="xx-p-12">
          <span>工单工时/天：</span>
          <span class="xx-content-color">{{ Tabular.workHours }}</span>
        </div>
      </div>
      <el-button size="mini" class="xx-m-b-6" type="primary" @click="addsafety"
        >添加</el-button
      >
      <el-form :model="ruleForm" ref="paramsForm">
        <el-table
          :data="ruleForm.orderTasks"
          style="width: 100%"
          stripe
          row-key="id"
          class="addTable"
        >
          <el-table-column label="序号" align="center" width="50" type="index">
          </el-table-column>
          <el-table-column
            label="任务名称"
            align="center"
            width="200"
            prop="taskName"
          >
            <template slot-scope="scope">
              <el-form-item
                :prop="`orderTasks[${scope.$index}].taskName`"
                :rules="[
                  {
                    required: true,
                    message: '请输入任务名称',
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input
                  v-model="scope.row.taskName"
                  placeholder="请输入任务名称"
                ></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="实际难度系数" align="center" width="140">
            <template slot-scope="scope">
              <el-form-item
                :prop="`orderTasks[${scope.$index}].realDegree`"
                :rules="[
                  {
                    required: true,
                    message: '请输入实际难度系数',
                    trigger: 'blur',
                  },
                ]"
              >
                <el-rate v-model="scope.row.realDegree"></el-rate>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="任务需求描述" align="center">
            <template slot-scope="scope">
              <el-form-item
                :prop="`orderTasks[${scope.$index}].taskDescription`"
                :rules="[
                  {
                    required: true,
                    message: '请输入任务需求描述',
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input
                  v-model="scope.row.taskDescription"
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 4 }"
                ></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="任务开始时间" align="center" width="150" :formatter="dateTimeTwoLine" class-name="cell-two-line">
            <template slot-scope="scope">
              <el-form-item
                :prop="`orderTasks[${scope.$index}].taskStartDate`"
                :rules="[
                  {
                    required: true,
                    message: '请选择任务开始时间',
                    trigger: 'blur',
                  },
                ]"
              >
                <el-date-picker
                  v-model="scope.row.taskStartDate"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="开始日期"
                  :picker-options="pickerOptionsStart"
                  @change="taskDays(scope.$index)"
                >
                </el-date-picker>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="任务结束时间" align="center" width="150" :formatter="dateTimeTwoLine" class-name="cell-two-line">
            <template slot-scope="scope">
              <el-form-item
                :prop="`orderTasks[${scope.$index}].taskEndDate`"
                :rules="[
                  {
                    required: true,
                    message: '请选择任务结束时间',
                    trigger: 'change',
                  },
                ]"
              >
                <el-date-picker
                  v-model="scope.row.taskEndDate"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="结束日期"
                  :picker-options="pickerOptionsEnd"
                  @change="taskDays(scope.$index)"
                >
                </el-date-picker>
              </el-form-item>
            </template>
          </el-table-column>
          <!-- <el-table-column label="任务工时/天" align="center" width="100">
            <template slot-scope="scope">
              <el-form-item :prop="`orderTasks[${scope.$index}].taskWorkHours`">
                <el-input v-model="scope.row.taskWorkHours" disabled></el-input>
              </el-form-item>
            </template>
          </el-table-column> -->
          <el-table-column label="人员" align="center" width="200">
            <template slot-scope="scope">
              <el-form-item
                :prop="`orderTasks[${scope.$index}].personIds`"
                :rules="[
                  {
                    required: true,
                    message: '请输入人员',
                    trigger: 'change',
                  },
                ]"
              >
                <el-select
                  v-model="scope.row.personIds"
                  multiple
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.id"
                    :label="item.trueName"
                    :value="item.id"
                  >
                    <span style="float: left">{{ item.trueName }}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px"
                      >进行中任务：{{ item.total }}</span
                    >
                  </el-option>
                </el-select>
              </el-form-item>
            </template>
          </el-table-column>

          <el-table-column label="操作" align="center" width="60">
            <template slot-scope="scope">
              <el-button
                type="text"
                class="red"
                @click="delesafety(scope.$index)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="submitTaskForm"
          :loading="submitLoading"
          >确 定</el-button
        >
        <el-button @click="resolveOpen = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 工单详情 -->
    <el-dialog
      title="任务进度详情"
      :visible.sync="dialogVisibleDeta"
      width="70%"
      :destroy-on-close="true"
    >
      <schedule :parentData="taskList"></schedule>
    </el-dialog>
    <!-- 工单评价 -->
    <el-dialog
      title="工单结单评价"
      :visible.sync="reputationOpen"
      width="30%"
      append-to-body
      :destroy-on-close="true"
      :close-on-click-modal="false"
      @close="reputationClose"
    >
      <el-form
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="GD-ruleForm"
      >
        <el-form-item label="服务态度" prop="serveAttitude">
          <el-rate
            v-model="reputation.serveAttitude"
            :colors="colors"
            :disabled="isReputation"
          >
          </el-rate>
        </el-form-item>
        <el-form-item label="服务质量" prop="serveQuality">
          <el-rate
            v-model="reputation.serveQuality"
            :colors="colors"
            :disabled="isReputation"
          >
          </el-rate>
        </el-form-item>
        <el-form-item label="服务效率" prop="serveSpeed">
          <el-rate
            v-model="reputation.serveSpeed"
            :colors="colors"
            :disabled="isReputation"
          >
          </el-rate>
        </el-form-item>
        <el-form-item label="评价内容" prop="evalContent">
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入内容"
            v-model="reputation.evalContent"
            :disabled="isReputation"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" v-if="!isReputation">
        <el-button
          type="primary"
          @click="submitEvaluate"
          :loading="submitLoading"
          >确 定</el-button
        >
        <el-button @click="reputationOpen = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getUserSelectByPage } from "@/api/plat/PlatStaff";
import schedule from "./components/schedule";
import {
  postWorkOrderList,
  postWorkOrderCreate,
  postWorkOrderChange,
  postWorkOrderReceive,
  orderInfoTasks,
  getPersonTask,
  postEvaluatea,
  getProjects,
  postWorkOrderDelete,
  getEvaluateaId,
} from "@/api/work/WorkOrderList";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { downloadFileByPost } from "@/utils/filenRequest.js";
import filters from "@/filters";

export default {
  components: { Treeselect, schedule },
  data() {
    return {
      // 自定义请求头
      customHeaders: {
        userIdStr: window.sessionStorage.getItem("userIdStr"),
      },
      UID: JSON.parse(window.sessionStorage.getItem("uid")),
      DEPARTMENTID: JSON.parse(window.sessionStorage.getItem("departmentId")),
      userList: [], //列表
      taskList: [], //列表
      options: [],
      CeOptions: [],
      userOptions: [], //人员
      qx: false, // 总经理、销售总监编辑的权限
      qx1: false, // 销售总监指派商机的权限
      defaultProps: {
        children: "children",
        label: "name",
      },
      // 总条数
      total: 0,
      // 遮罩层
      loading: false,
      submitLoading: false,

      // 非多个禁用
      multiple: true,
      // 是否显示弹出层
      open: false,
      resolveOpen: false,
      dialogVisibleDeta: false,
      reputationOpen: false,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      orderId: null,
      fileList: null,
      reputation: {
        evalContent: "",
        orderId: "",
        serveAttitude: null,
        serveQuality: null,
        serveSpeed: null,
      },
      colors: ["#99A9BF", "#F7BA2A", "#FF9900"],
      // 表单参数
      form: {
        deptName: "",
        deptId: null,
        description: "",
        endDate: "",
        orderId: "",
        personId: null,
        projectId: null,
        orderId: null,
        name: "",
        startDate: "",
        workHours: "",
        orderFileUrl: "",
        fileFlag: "3", //附件名称
      },
      FileUrl: [], //存文件的数组
      isReputation: false, //是否评价
      ruleForm: {
        orderTasks: [
          {
            taskDescription: null,
            taskEndDate: null,
            taskExecutePerson: null,
            taskName: null,
            taskOfPerson: null,
            taskStartDate: null,
            taskWorkHours: null,
            orderId: null,
            personIds: [],
          },
        ],
        orderId: "",
      },
      Tabular: {}, //列表展示数据
      projects: [], //项目id-项目名称下拉框
      // 弹出层标题
      title: "",
      // 部门树选项
      deptOptions: [],
      SelectedTerm: null,
      queryParams: {
        condition: {
          keyWord: "",
        },
        limit: 50,
        page: 1,
        orders: [
          {
            asc: true,
            column: "createTime",
          },
        ],
      },
      // 表单校验
      rules: {
        taskName: [
          { required: true, message: "任务名称不能为空", trigger: "change" },
        ],
        realDegree: [
          { required: true, message: "难度系数不能为空", trigger: "change" },
        ],
        name: [
          { required: true, message: "工单名称不能为空", trigger: "blur" },
        ],
        deptId: [
          { required: true, message: "部门不能为空", trigger: "change" },
        ],
        endDate: [
          { required: true, message: "日期不能为空", trigger: "change" },
        ],
        description: [
          {
            required: true,
            message: "工单需求描述不能为空",
            trigger: "change",
          },
        ],
      },
      //判断时间不能选择今天以前的时间
      pickerOptionsStart: {
        // disabledDate(time) {
        //   var timeNow = Date.now();
        //   var before = timeNow - 24 * 60 * 60 * 1000;
        //   return time.getTime() <= before;
        // },
      },
      //判断时间选择上个选择时间之后的时间
      pickerOptionsEnd: {
        // disabledDate: (time) => {
        //   var timeNow = Date.now();
        //   var before = timeNow - 24 * 60 * 60 * 1000;
        //   // if (this.ruleForm.orderTasks[this.SelectedTerm].taskStartDate != "") {
        //   //   return (
        //   //     time.getTime() <=
        //   //       new Date(
        //   //         this.ruleForm.orderTasks[this.SelectedTerm].taskStartDate
        //   //       ).getTime() || time.getTime() < Date.now() - 8.64e7
        //   //   );
        //   // } else {
        //   //还没有选择结束时间的时候，让他只能选择今天之后的时间包括今天
        //   return time.getTime() < before;
        //   // }
        // },
      },
      //判断时间选择上个选择时间之后的时间
      pickerOptionsEndCreated: {
        // disabledDate: (time) => {
        //   var timeNow = Date.now();
        //   var before = timeNow - 24 * 60 * 60 * 1000;
        //   if (this.form.startDate != "") {
        //     return (
        //       time.getTime() < new Date(this.form.startDate).getTime() ||
        //       time.getTime() < Date.now() - 8.64e7
        //     );
        //   } else {
        //     //还没有选择结束时间的时候，让他只能选择今天之后的时间包括今天
        //     return time.getTime() < before;
        //   }
        // },
      },
    };
  },
  async created() {
    this.getList();
    this.$nextTick(() => {
      // 通过 DOM API 更新文本
      this.quanxian();
    });
    let deptArr = await this.getDimTableDeptByIds([214]);
    this.deptOptions = deptArr.data;
  },
  methods: {
    /** 查询用户列表 */
    async getList() {
      this.loading = true;
      let { data } = await postWorkOrderList(this.queryParams);
      this.userList = data.records;
      this.total = data.total;
      //获取项目
      getProjects().then((resp) => {
        this.projects = resp.data;
      });
      this.loading = false;
    },
    // 节点单击事件
    async handleSelect(node, instanceId) {
      if (node.type) {
        this.form.personId = null;
      }
      this.form.deptName = node.name;
      let { data } = await getUserSelectByPage({
        condition: {
          departmentId: node.id,
        },
        limit: 9999,
        page: 1,
      });
      let fixed = [{ id: null, trueName: "部门接单" }];
      this.CeOptions = fixed.concat(data.records);
      if (instanceId == 1) return false;
      this.$nextTick(() => {
        this.$refs["form"].validateField("deptId");
      });
    },
    //详情
    async viewDetails(row) {
      let { data } = await orderInfoTasks(row.id);
      this.taskList = data;
      this.dialogVisibleDeta = true;
    },
    //工单拆分
    async handleAccept(row) {
      this.resolveOpen = true;
      this.Tabular = row;
      this.orderId = row.id;
      this.ruleForm.orderId = row.id;
      this.ruleForm.orderTasks[0].orderId = row.id;
      let { data } = await getPersonTask(JSON.stringify(row.deptId));
      this.options = data;
    },
    /** 修改按钮操作 */
    async handleUpdate(row) {
      this.form = row;
      this.form.orderId = row.id;
      this.open = true;
      this.title = "变更工单";
      let { data } = await getUserSelectByPage({
        data: {
          departmentId: row.deptId,
        },
      });
      this.options = data.list;
    },
    //结单
    handleResult(e) {
      this.reputationOpen = true;
      this.reputation.orderId = e.id;
    },
    // 表单重置
    reset() {
      this.form = {
        deptName: "",
        description: "",
        endDate: "",
        orderId: "",
        personId: null,
        projectId: null,
        orderId: null,
        name: "",
        startDate: "",
        workHours: "",
        deptId: null,
        orderFileUrl: "",
      };
    },
    //变更工单
    Alteration(row) {
      this.open = true;
      this.title = "变更工单";
      this.form = row;
      if (row.orderFileUrl != "" && row.orderFileUrl != null) {
        this.FileUrl.push({
          name: row.orderFileUrl.split("/").slice(-1)[0],
          url: row.orderFileUrl,
        });
      }
      this.form.endDate = filters.timestampToTimeB(row.endDate);
      this.form.startDate = filters.timestampToTimeB(row.startDate);
      this.form.personId = Number(row.personId) || null;
      this.form.orderId = row.id;
      this.form.fileFlag = "3"; //附件名称
      this.handleSelect({ id: row.deptId, name: row.deptName });
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.page = 1;
      this.getList();
    },

    /** 新增按钮操作 */
    handleAdd() {
      this.open = true;
      this.title = "创建工单";
    },
    //附件下载
    async downloadFile(url) {
      downloadFileByPost(url.orderFileUrl);
    },
    // 评价
    reputationClose() {
      this.isReputation = false;
      this.reputation = {
        evalContent: "",
        orderId: "",
        serveAttitude: null,
        serveQuality: null,
        serveSpeed: null,
      };
    },
    //评价详情
    async handleDetails(e) {
      let { data } = await getEvaluateaId(e.evalId);
      this.reputation = data;
      this.reputationOpen = true;
      this.isReputation = true;
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParams.condition.keyWord = undefined;
      this.getList();
    },

    //新增任务
    addsafety() {
      this.ruleForm.orderTasks.push({
        deptName: null,
        orderId: this.orderId,
        projectName: null,
        realDegree: null,
        taskDescription: null,
        taskEndDate: null,
        taskExecutePerson: 0,
        taskName: null,
        taskOfPerson: null,
        taskStartDate: null,
        taskWorkHours: null,
      });
    },
    //删除任务
    delesafety(index) {
      if (this.ruleForm.orderTasks.length < 2) {
        this.$message({
          message: "最少要一个",
          type: "warning",
        });
        return;
      }
      this.ruleForm.orderTasks.splice(index, 1);
    },
    //时间的计算
    calculateDays() {
      let currentDate = new Date();
      let y = currentDate.getFullYear();
      let m = currentDate.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      let d =
        currentDate.getDate() < 10
          ? "0" + currentDate.getDate()
          : currentDate.getDate();
      const endDate = new Date(this.form.endDate);
      const newData = new Date(y + "-" + m + "-" + d);
      // if (currentDate > endDate) {
      //   this.$message({
      //     message: "开始时间不能大于结束时间",
      //     type: "warning",
      //   });
      //   this.form.startDate = "";
      //   this.form.endDate = "";
      //   return;
      // }
      let days = 0;
      while (newData <= endDate) {
        if (newData.getDay() % 6 !== 0) {
          // 判断是否为周末（周六或周日）
          days++;
        }
        newData.setDate(newData.getDate() + 1);
      }
      this.form.workHours = days;
    },
    //时间的计算 orderTasks
    taskDays(index) {
      this.SelectedTerm = index;
      if (
        this.ruleForm.orderTasks[index].taskStartDate &&
        this.ruleForm.orderTasks[index].taskEndDate
      ) {
        let currentDate = new Date(
          this.ruleForm.orderTasks[index].taskStartDate
        );
        const endDate = new Date(this.ruleForm.orderTasks[index].taskEndDate);
        let days = 0;
        while (currentDate <= endDate) {
          if (currentDate.getDay() % 6 !== 0) {
            // 判断是否为周末（周六或周日）
            days++;
          }
          currentDate.setDate(currentDate.getDate() + 1);
        }
        this.ruleForm.orderTasks[index].taskWorkHours = days;
      }
    },
    /** 转换部门数据结构 */
    normalizer(node) {
      if (node.children && !node.children.length) {
        delete node.children;
      }
      return {
        id: node.id,
        label: node.name,
        children: node.children,
      };
    },
    //权限
    quanxian() {
      // 创建工单
      if (
        this.doesItContain([
          1, 2, 6, 26, 32, 34, 35, 36, 37, 38, 42, 43, 44, 47,
        ]).length > 0
      ) {
        this.qx = true;
      }
      if (
        this.doesItContain([1, 6, 26, 32, 34, 35, 36, 38, 42, 43, 44]).length >
        0
      ) {
        // 部门主管接收工单
        this.qx1 = true;
      }
    },
    //删除工单
    async deleteWorkOrder(row) {
      try {
        await this.$confirm("是否确认删除该工单?", "警告", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
        let res = await postWorkOrderDelete(row.id);
        if (res.code == 200) {
          this.$message({
            message: "删除成功",
            type: "success",
          });
        }
        this.getList();
      } catch (error) {
        return Promise.reject(error);
      }
    },
    handleClose() {
      this.FileUrl = [];
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
      this.FileUrl = [];
    },
    //工单评价
    async submitEvaluate() {
      this.submitLoading = true;
      try {
        let res = await postEvaluatea(this.reputation);
        if (res.code == 200) {
          this.$message({
            message: "提交成功",
            type: "success",
          });
          this.reputation = {
            evalContent: "",
            orderId: "",
            serveAttitude: null,
            serveQuality: null,
            serveSpeed: null,
          };
          this.getList();
          this.reputationOpen = false;
          this.submitLoading = false;
        }
      } catch (error) {
        return Promise.reject(error);
      }
    },
    //部门主管接收工单
    submitTaskForm() {
      this.$refs["paramsForm"].validate(async (valid) => {
        if (valid) {
          this.submitLoading = true;
          try {
            let res = await postWorkOrderReceive(this.ruleForm);
            if (res.code == 200) {
              this.$message({
                message: "提交成功",
                type: "success",
              });
              this.ruleForm = {
                orderTasks: [
                  {
                    taskDescription: null,
                    taskEndDate: null,
                    taskExecutePerson: null,
                    taskName: null,
                    taskOfPerson: null,
                    taskStartDate: null,
                    taskWorkHours: null,
                    orderId: null,
                    personIds: [],
                  },
                ],
              };
            }
            this.getList();
            this.resolveOpen = false;
            this.submitLoading = false;
          } catch (error) {
            return Promise.reject(error);
          }
        }
      });
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.submitLoading = true;
          if (this.form.id != undefined) {
            delete this.form.userName;
            try {
              let res = await postWorkOrderChange(this.form);
              if (res.code == 200) {
                this.$message({
                  message: "修改成功",
                  type: "success",
                });
                this.reset();
                this.open = false;
              }
              this.submitLoading = false;
              this.getList();
            } catch (error) {
              return Promise.reject(error);
            }
          } else {
            try {
              let res = await postWorkOrderCreate(this.form);
              if (res.code == 200) {
                this.$message({
                  message: "创建成功",
                  type: "success",
                });
                this.reset();
                this.open = false;
              }
              this.submitLoading = false;

              this.getList();
            } catch (error) {
              return Promise.reject(error);
            }
          }
        }
      });
    },
    handleSuccess(file, fileList) {
      this.fileList = file;
      this.form.orderFileUrl = file.data.fileUrl;
      console.log(this.form.orderFileUrl);
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    handleRemove(file, fileList) {
      this.form.orderFileUrl = "";
      this.fileList = [];
    },
  },
};
</script>
<style lang="scss" scoped>
.upload-demo {
  width: 50%;
}
.dialog-box ::v-deep .el-form-item {
  margin-bottom: 0 !important;
}
.addTable ::v-deep .el-date-editor.el-input {
  width: 140px;
}
.el-row {
  margin-bottom: 20px;
}
.el-select-dropdown.is-multiple .el-select-dropdown__item {
  padding: 0 20px;
}
::v-deep .el-rate {
  line-height: 2.5;
}
.GD-ruleForm ::v-deep .el-form-item {
  margin-bottom: 0;
}
</style>
<style>
.el-tooltip__popper {
  max-width: 500px;
}
</style>

